import { useFeatureIsOn } from 'growthbook'
import * as React from 'react'

export const WORKSPACE_STORAGE_KEY = 'studio:selected-team-id'

export function getSelectedWorkspaceId(): string | null {
  try {
    return window.localStorage.getItem(WORKSPACE_STORAGE_KEY)?.trim() || null
  } catch {
    return null
  }
}

export function getWorkspaceId(): string | null {
  if (typeof window === 'undefined') {
    return null
  }
  return window.globalGrowthBook?.isOn('studio-team-workspaces') ? getSelectedWorkspaceId() : null
}

export function setSelectedWorkspaceId(teamId: string | null) {
  const value = teamId?.trim() || null
  if (value) {
    window.localStorage.setItem(WORKSPACE_STORAGE_KEY, value)
  } else {
    window.localStorage.removeItem(WORKSPACE_STORAGE_KEY)
  }
  window.dispatchEvent(new StorageEvent('storage', { key: WORKSPACE_STORAGE_KEY, newValue: value }))
}

function subscribe(onChange: () => void) {
  const onStorage = (event: StorageEvent) => {
    if (event.key === WORKSPACE_STORAGE_KEY || event.key === null) {
      onChange()
    }
  }
  window.addEventListener('storage', onStorage)
  return () => window.removeEventListener('storage', onStorage)
}

const getServerSnapshot = () => null

export function useSelectedWorkspaceId() {
  return React.useSyncExternalStore(subscribe, getSelectedWorkspaceId, getServerSnapshot)
}

export function useWorkspaceQuery() {
  const enabled = useFeatureIsOn('studio-team-workspaces')
  const teamId = useSelectedWorkspaceId()
  return { data: enabled ? teamId : null }
}
